$(function() {

//==========================================================================
// MODULE STATE
//==========================================================================

var $components;

//==========================================================================
// ENTRY POINT
//==========================================================================

init();

//==========================================================================
// INIT
//==========================================================================

//-----

function init() {
    // init module state
    initModuleState();

    // if there are no related components on the page, return
    if (!$components.length) return;

    $components.on('click', '.video-link a, .video-close', function(e) {
        e.preventDefault();
        toggleYoutubeVideo($(this).closest('.video-youtube'));
    });

    if (isMobile.any() && $("section.preguntas-frecuentes-coronita").find(".video-youtube").length < 1) {
        // for each component, do stuff
        __($components).each(manageComponent);
    }
}

//-----

//==========================================================================
// FUNCTIONS
//==========================================================================


//-----

function initModuleState() {
    $components = $('.video-youtube');
}

//-----

function manageComponent(component) {
    var $component = $(component);

    $component.find('.video-link a').remove();

    // create the video
    var $videoIframe = $(getYoutubeVideo(
        $component.closest('.video-youtube')));

    // append the video
    $component.find('.video-link').append($videoIframe);

    if (window.bbva && window.bbva.processVideoForDatalayer) {
        window.bbva.processVideoForDatalayer($videoIframe[0]);
    }
}

//-----

function toggleYoutubeVideo(sec) {
    var $videoBlock = sec.children('.video-block');

    if (!$videoBlock.data('video-playing')) {
        sec.addClass('blurred');
        setTimeout(function() {
            sec.addClass('show-layer');

            setTimeout(function() {
                sec.find('.video-container').append(getYoutubeVideo(sec));
                sec.addClass('active');
            }, 600);
        }, 500);
        $videoBlock.data('video-playing', true);
    }
    else {
        sec.removeClass('active');
        setTimeout(function() {
            sec.removeClass('show-layer');
            setTimeout(function() {
                sec.removeClass('blurred');

                $videoBlock.find('.video-container').children().remove();
            }, 500);
        }, 400);
        $videoBlock.data('video-playing', false);
    }
}

//-----

function getYoutubeVideo(sec) {
    var vwidth = sec.find('.video-block .container').width(),
    vheight = sec.find('.video-block .container').height();

    var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
    var strVideo = sec.data('video-id');
    if (strVideo.indexOf("?") == -1 ){
        return '<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&autoplay=1&enablejsapi=1" width="' + vwidth + '" height="' + vheight + '" frameborder="0" allowfullscreen></iframe>';
    }
    else {
        return '<iframe id="'+ id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&autoplay=1&enablejsapi=1" width="' + vwidth + '" height="' + vheight + '" frameborder="0" allowfullscreen></iframe>';
    }
}

//-----

});
